import { render, staticRenderFns } from "./IntroSlideCard.vue?vue&type=template&id=319adade&scoped=true"
import script from "./IntroSlideCard.vue?vue&type=script&lang=js"
export * from "./IntroSlideCard.vue?vue&type=script&lang=js"
import style0 from "./IntroSlideCard.vue?vue&type=style&index=0&id=319adade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319adade",
  null
  
)

export default component.exports